import React from "react";

const logos = [
  { src: "/CustomersLogo/azimut.png", alt: "AZIMUT - Asset Management Company, Keops Client", height: "h-8" },
  { src: "/CustomersLogo/zeidler.png", alt: "Zeidler - Financial Services Partner, Keops Client", height: "h-8" },
  { src: "/CustomersLogo/eib.png", alt: "EIB - European Investment Bank, Keops Client", height: "h-9" },
  { src: "/CustomersLogo/aifm-services.png", alt: "AIFM Services - Alternative Investment Fund Management, Keops Client", height: "h-8" },
  { src: "/CustomersLogo/kneip.png", alt: "KNEIP - Fund Technology Solutions, Keops Client", height: "h-8" },
  { src: "/CustomersLogo/assenagon.png", alt: "Assenagon - Asset Management Company", height: "h-8" },
  { src: "/CustomersLogo/bny_mellon.png", alt: "BNY Mellon", height: "h-8" },
  { src: "/CustomersLogo/degroof-petercam.png", alt: "Degroof Petercam - Asset Management Company", height: "h-8" },
  { src: "/CustomersLogo/amundi.png", alt: "Amundi - Asset Management Company", height: "h-9" },
];

const CustomerLogos: React.FC = () => {
  return (
    <section className="py-8 sm:py-12 lg:py-16 bg-gray-700 border-b border-gray-600">
      <style>{`
        @keyframes marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .logo-track {
          animation: marquee 24s linear infinite;
        }
        .logo-track:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-lg sm:text-xl lg:text-2xl font-semibold text-white mb-2">
            Trusted by
          </h2>
        </div>

        {/* Carousel */}
        <div className="overflow-hidden" style={{ maskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)" }}>
          <div className="logo-track flex items-center" style={{ width: "max-content" }}>
            {[...logos, ...logos].map((logo, index) => (
              <div
                key={index}
                className="flex items-center justify-center h-14 mx-10"
                style={{ minWidth: "112px" }}
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className={`${logo.height} w-auto object-contain`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Trust Statistics */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6 mt-6 lg:mt-8">
          <div className="text-center">
            <div className="text-xl lg:text-2xl font-bold text-blue-400 mb-1">
              726+
            </div>
            <div className="text-xs lg:text-sm text-gray-400">Funds</div>
            <div className="text-xs lg:text-sm text-gray-400">
              3271 share classes for total AUM 2.83B €
            </div>
          </div>
          <div className="text-center">
            <div className="text-xl lg:text-2xl font-bold text-green-400 mb-1">
              53%
            </div>
            <div className="text-xs lg:text-sm text-gray-400">
              PRIIPS, UCITS, AIFMD &amp; SII
            </div>
            <div className="text-xs lg:text-sm text-gray-400">
              Including the PRIIPs calculations, UCITS risk reporting, Annex IV and TPT
            </div>
          </div>
          <div className="text-center">
            <div className="text-xl lg:text-2xl font-bold text-yellow-400 mb-1">
              47%
            </div>
            <div className="text-xs lg:text-sm text-gray-400">
              ESG Factsheet &amp; Factsheet Risk Figures
            </div>
            <div className="text-xs lg:text-sm text-gray-400">
              Risk measures including Alpha, R-Squared, Rolling period performance and more
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerLogos;
